/*
 * SPDX-FileCopyrightText: syuilo and misskey-project
 * SPDX-License-Identifier: AGPL-3.0-only
 */

// TODO: sharedに置いてバックエンドのと統合したい
export const langmap = {
	'ach': {
		nativeName: 'Lwo',
	},
	'ady': {
		nativeName: 'Адыгэбзэ',
	},
	'af': {
		nativeName: 'Afrikaans',
	},
	'af-NA': {
		nativeName: 'Afrikaans (Namibia)',
	},
	'af-ZA': {
		nativeName: 'Afrikaans (South Africa)',
	},
	'ak': {
		nativeName: 'Tɕɥi',
	},
	'ar': {
		nativeName: 'العربية',
	},
	'ar-AR': {
		nativeName: 'العربية',
	},
	'ar-MA': {
		nativeName: 'العربية',
	},
	'ar-SA': {
		nativeName: 'العربية (السعودية)',
	},
	'ay-BO': {
		nativeName: 'Aymar aru',
	},
	'az': {
		nativeName: 'Azərbaycan dili',
	},
	'az-AZ': {
		nativeName: 'Azərbaycan dili',
	},
	'be-BY': {
		nativeName: 'Беларуская',
	},
	'bg': {
		nativeName: 'Български',
	},
	'bg-BG': {
		nativeName: 'Български',
	},
	'bn': {
		nativeName: 'বাংলা',
	},
	'bn-IN': {
		nativeName: 'বাংলা (ভারত)',
	},
	'bn-BD': {
		nativeName: 'বাংলা(বাংলাদেশ)',
	},
	'br': {
		nativeName: 'Brezhoneg',
	},
	'bs-BA': {
		nativeName: 'Bosanski',
	},
	'ca': {
		nativeName: 'Català',
	},
	'ca-ES': {
		nativeName: 'Català',
	},
	'cak': {
		nativeName: 'Maya Kaqchikel',
	},
	'ck-US': {
		nativeName: 'ᏣᎳᎩ (tsalagi)',
	},
	'cs': {
		nativeName: 'Čeština',
	},
	'cs-CZ': {
		nativeName: 'Čeština',
	},
	'cy': {
		nativeName: 'Cymraeg',
	},
	'cy-GB': {
		nativeName: 'Cymraeg',
	},
	'da': {
		nativeName: 'Dansk',
	},
	'da-DK': {
		nativeName: 'Dansk',
	},
	'de': {
		nativeName: 'Deutsch',
	},
	'de-AT': {
		nativeName: 'Deutsch (Österreich)',
	},
	'de-DE': {
		nativeName: 'Deutsch (Deutschland)',
	},
	'de-CH': {
		nativeName: 'Deutsch (Schweiz)',
	},
	'dsb': {
		nativeName: 'Dolnoserbšćina',
	},
	'el': {
		nativeName: 'Ελληνικά',
	},
	'el-GR': {
		nativeName: 'Ελληνικά',
	},
	'en': {
		nativeName: 'English',
	},
	'en-GB': {
		nativeName: 'English (UK)',
	},
	'en-AU': {
		nativeName: 'English (Australia)',
	},
	'en-CA': {
		nativeName: 'English (Canada)',
	},
	'en-IE': {
		nativeName: 'English (Ireland)',
	},
	'en-IN': {
		nativeName: 'English (India)',
	},
	'en-PI': {
		nativeName: 'English (Pirate)',
	},
	'en-SG': {
		nativeName: 'English (Singapore)',
	},
	'en-UD': {
		nativeName: 'English (Upside Down)',
	},
	'en-US': {
		nativeName: 'English (US)',
	},
	'en-ZA': {
		nativeName: 'English (South Africa)',
	},
	'en@pirate': {
		nativeName: 'English (Pirate)',
	},
	'eo': {
		nativeName: 'Esperanto',
	},
	'eo-EO': {
		nativeName: 'Esperanto',
	},
	'es': {
		nativeName: 'Español',
	},
	'es-AR': {
		nativeName: 'Español (Argentine)',
	},
	'es-419': {
		nativeName: 'Español (Latinoamérica)',
	},
	'es-CL': {
		nativeName: 'Español (Chile)',
	},
	'es-CO': {
		nativeName: 'Español (Colombia)',
	},
	'es-EC': {
		nativeName: 'Español (Ecuador)',
	},
	'es-ES': {
		nativeName: 'Español (España)',
	},
	'es-LA': {
		nativeName: 'Español (Latinoamérica)',
	},
	'es-NI': {
		nativeName: 'Español (Nicaragua)',
	},
	'es-MX': {
		nativeName: 'Español (México)',
	},
	'es-US': {
		nativeName: 'Español (Estados Unidos)',
	},
	'es-VE': {
		nativeName: 'Español (Venezuela)',
	},
	'et': {
		nativeName: 'eesti keel',
	},
	'et-EE': {
		nativeName: 'Eesti (Estonia)',
	},
	'eu': {
		nativeName: 'Euskara',
	},
	'eu-ES': {
		nativeName: 'Euskara',
	},
	'fa': {
		nativeName: 'فارسی',
	},
	'fa-IR': {
		nativeName: 'فارسی',
	},
	'fb-LT': {
		nativeName: 'Leet Speak',
	},
	'ff': {
		nativeName: 'Fulah',
	},
	'fi': {
		nativeName: 'Suomi',
	},
	'fi-FI': {
		nativeName: 'Suomi',
	},
	'fo': {
		nativeName: 'Føroyskt',
	},
	'fo-FO': {
		nativeName: 'Føroyskt (Færeyjar)',
	},
	'fr': {
		nativeName: 'Français',
	},
	'fr-CA': {
		nativeName: 'Français (Canada)',
	},
	'fr-FR': {
		nativeName: 'Français (France)',
	},
	'fr-BE': {
		nativeName: 'Français (Belgique)',
	},
	'fr-CH': {
		nativeName: 'Français (Suisse)',
	},
	'fy-NL': {
		nativeName: 'Frysk',
	},
	'ga': {
		nativeName: 'Gaeilge',
	},
	'ga-IE': {
		nativeName: 'Gaeilge',
	},
	'gd': {
		nativeName: 'Gàidhlig',
	},
	'gl': {
		nativeName: 'Galego',
	},
	'gl-ES': {
		nativeName: 'Galego',
	},
	'gn-PY': {
		nativeName: 'Avañe\'ẽ',
	},
	'gu-IN': {
		nativeName: 'ગુજરાતી',
	},
	'gv': {
		nativeName: 'Gaelg',
	},
	'gx-GR': {
		nativeName: 'Ἑλληνική ἀρχαία',
	},
	'he': {
		nativeName: 'עברית‏',
	},
	'he-IL': {
		nativeName: 'עברית‏',
	},
	'hi': {
		nativeName: 'हिन्दी',
	},
	'hi-IN': {
		nativeName: 'हिन्दी',
	},
	'hr': {
		nativeName: 'Hrvatski',
	},
	'hr-HR': {
		nativeName: 'Hrvatski',
	},
	'hsb': {
		nativeName: 'Hornjoserbšćina',
	},
	'ht': {
		nativeName: 'Kreyòl',
	},
	'hu': {
		nativeName: 'Magyar',
	},
	'hu-HU': {
		nativeName: 'Magyar',
	},
	'hy': {
		nativeName: 'Հայերեն',
	},
	'hy-AM': {
		nativeName: 'Հայերեն (Հայաստան)',
	},
	'id': {
		nativeName: 'Bahasa Indonesia',
	},
	'id-ID': {
		nativeName: 'Bahasa Indonesia',
	},
	'is': {
		nativeName: 'Íslenska',
	},
	'is-IS': {
		nativeName: 'Íslenska (Iceland)',
	},
	'it': {
		nativeName: 'Italiano',
	},
	'it-IT': {
		nativeName: 'Italiano',
	},
	'ja': {
		nativeName: '日本語',
	},
	'ja-JP': {
		nativeName: '日本語 (日本)',
	},
	'jv-ID': {
		nativeName: 'Basa Jawa',
	},
	'ka-GE': {
		nativeName: 'ქართული',
	},
	'kk-KZ': {
		nativeName: 'Қазақша',
	},
	'km': {
		nativeName: 'ភាសាខ្មែរ',
	},
	'kl': {
		nativeName: 'kalaallisut',
	},
	'km-KH': {
		nativeName: 'ភាសាខ្មែរ',
	},
	'kab': {
		nativeName: 'Taqbaylit',
	},
	'kn': {
		nativeName: 'ಕನ್ನಡ',
	},
	'kn-IN': {
		nativeName: 'ಕನ್ನಡ (India)',
	},
	'ko': {
		nativeName: '한국어',
	},
	'ko-KR': {
		nativeName: '한국어 (한국)',
	},
	'ku-TR': {
		nativeName: 'Kurdî',
	},
	'kw': {
		nativeName: 'Kernewek',
	},
	'la': {
		nativeName: 'Latin',
	},
	'la-VA': {
		nativeName: 'Latin',
	},
	'lb': {
		nativeName: 'Lëtzebuergesch',
	},
	'li-NL': {
		nativeName: 'Lèmbörgs',
	},
	'lt': {
		nativeName: 'Lietuvių',
	},
	'lt-LT': {
		nativeName: 'Lietuvių',
	},
	'lv': {
		nativeName: 'Latviešu',
	},
	'lv-LV': {
		nativeName: 'Latviešu',
	},
	'mai': {
		nativeName: 'मैथिली, মৈথিলী',
	},
	'mg-MG': {
		nativeName: 'Malagasy',
	},
	'mk': {
		nativeName: 'Македонски',
	},
	'mk-MK': {
		nativeName: 'Македонски (Македонски)',
	},
	'ml': {
		nativeName: 'മലയാളം',
	},
	'ml-IN': {
		nativeName: 'മലയാളം',
	},
	'mn-MN': {
		nativeName: 'Монгол',
	},
	'mr': {
		nativeName: 'मराठी',
	},
	'mr-IN': {
		nativeName: 'मराठी',
	},
	'ms': {
		nativeName: 'Bahasa Melayu',
	},
	'ms-MY': {
		nativeName: 'Bahasa Melayu',
	},
	'mt': {
		nativeName: 'Malti',
	},
	'mt-MT': {
		nativeName: 'Malti',
	},
	'my': {
		nativeName: 'ဗမာစကာ',
	},
	'no': {
		nativeName: 'Norsk',
	},
	'nb': {
		nativeName: 'Norsk (bokmål)',
	},
	'nb-NO': {
		nativeName: 'Norsk (bokmål)',
	},
	'ne': {
		nativeName: 'नेपाली',
	},
	'ne-NP': {
		nativeName: 'नेपाली',
	},
	'nl': {
		nativeName: 'Nederlands',
	},
	'nl-BE': {
		nativeName: 'Nederlands (België)',
	},
	'nl-NL': {
		nativeName: 'Nederlands (Nederland)',
	},
	'nn-NO': {
		nativeName: 'Norsk (nynorsk)',
	},
	'oc': {
		nativeName: 'Occitan',
	},
	'or-IN': {
		nativeName: 'ଓଡ଼ିଆ',
	},
	'pa': {
		nativeName: 'ਪੰਜਾਬੀ',
	},
	'pa-IN': {
		nativeName: 'ਪੰਜਾਬੀ (ਭਾਰਤ ਨੂੰ)',
	},
	'pl': {
		nativeName: 'Polski',
	},
	'pl-PL': {
		nativeName: 'Polski',
	},
	'ps-AF': {
		nativeName: 'پښتو',
	},
	'pt': {
		nativeName: 'Português',
	},
	'pt-BR': {
		nativeName: 'Português (Brasil)',
	},
	'pt-PT': {
		nativeName: 'Português (Portugal)',
	},
	'qu-PE': {
		nativeName: 'Qhichwa',
	},
	'rm-CH': {
		nativeName: 'Rumantsch',
	},
	'ro': {
		nativeName: 'Română',
	},
	'ro-RO': {
		nativeName: 'Română',
	},
	'ru': {
		nativeName: 'Русский',
	},
	'ru-RU': {
		nativeName: 'Русский',
	},
	'sa-IN': {
		nativeName: 'संस्कृतम्',
	},
	'se-NO': {
		nativeName: 'Davvisámegiella',
	},
	'sh': {
		nativeName: 'српскохрватски',
	},
	'si-LK': {
		nativeName: 'සිංහල',
	},
	'sk': {
		nativeName: 'Slovenčina',
	},
	'sk-SK': {
		nativeName: 'Slovenčina (Slovakia)',
	},
	'sl': {
		nativeName: 'Slovenščina',
	},
	'sl-SI': {
		nativeName: 'Slovenščina',
	},
	'so-SO': {
		nativeName: 'Soomaaliga',
	},
	'sq': {
		nativeName: 'Shqip',
	},
	'sq-AL': {
		nativeName: 'Shqip',
	},
	'sr': {
		nativeName: 'Српски',
	},
	'sr-RS': {
		nativeName: 'Српски (Serbia)',
	},
	'su': {
		nativeName: 'Basa Sunda',
	},
	'sv': {
		nativeName: 'Svenska',
	},
	'sv-SE': {
		nativeName: 'Svenska',
	},
	'sw': {
		nativeName: 'Kiswahili',
	},
	'sw-KE': {
		nativeName: 'Kiswahili',
	},
	'ta': {
		nativeName: 'தமிழ்',
	},
	'ta-IN': {
		nativeName: 'தமிழ்',
	},
	'te': {
		nativeName: 'తెలుగు',
	},
	'te-IN': {
		nativeName: 'తెలుగు',
	},
	'tg': {
		nativeName: 'забо́ни тоҷикӣ́',
	},
	'tg-TJ': {
		nativeName: 'тоҷикӣ',
	},
	'th': {
		nativeName: 'ภาษาไทย',
	},
	'th-TH': {
		nativeName: 'ภาษาไทย (ประเทศไทย)',
	},
	'fil': {
		nativeName: 'Filipino',
	},
	'tlh': {
		nativeName: 'tlhIngan-Hol',
	},
	'tr': {
		nativeName: 'Türkçe',
	},
	'tr-TR': {
		nativeName: 'Türkçe',
	},
	'tt-RU': {
		nativeName: 'татарча',
	},
	'uk': {
		nativeName: 'Українська',
	},
	'uk-UA': {
		nativeName: 'Українська',
	},
	'ur': {
		nativeName: 'اردو',
	},
	'ur-PK': {
		nativeName: 'اردو',
	},
	'uz': {
		nativeName: 'O\'zbek',
	},
	'uz-UZ': {
		nativeName: 'O\'zbek',
	},
	'vi': {
		nativeName: 'Tiếng Việt',
	},
	'vi-VN': {
		nativeName: 'Tiếng Việt',
	},
	'xh-ZA': {
		nativeName: 'isiXhosa',
	},
	'yi': {
		nativeName: 'ייִדיש',
	},
	'yi-DE': {
		nativeName: 'ייִדיש (German)',
	},
	'zh': {
		nativeName: '中文',
	},
	'zh-Hans': {
		nativeName: '中文简体',
	},
	'zh-Hant': {
		nativeName: '中文繁體',
	},
	'zh-CN': {
		nativeName: '中文（中国大陆）',
	},
	'zh-HK': {
		nativeName: '中文（香港）',
	},
	'zh-SG': {
		nativeName: '中文（新加坡）',
	},
	'zh-TW': {
		nativeName: '中文（台灣）',
	},
	'zu-ZA': {
		nativeName: 'isiZulu',
	},
};

export const postingLangCodes = ['ja-JP', 'ko-KR', 'other'] as const;
